import debugLog from "./debugLog";
import { reportAppWarning } from "./reportAppError";

type TrackedEventName = "chat_requested" | "chat_started" | "contact_first_message";

const TRACKED_EVENTS: TrackedEventName[] = [
  "chat_requested",
  "chat_started",
  "contact_first_message",
];

interface EventStatusMap {
  chat_requested: boolean;
  chat_started: boolean;
  contact_first_message: boolean;
}

const getEventStatus = (): EventStatusMap => {
  try {
    const stored = sessionStorage.getItem("trackChatEvent");
    if (stored) return JSON.parse(stored) as EventStatusMap;
  } catch {
    sessionStorage.removeItem("trackChatEvent");
  }

  const initial: EventStatusMap = {
    chat_requested: false,
    chat_started: false,
    contact_first_message: false,
  };
  sessionStorage.setItem("trackChatEvent", JSON.stringify(initial));
  return initial;
};

export function trackChatEvent(
  eventName: string,
  onChatEvent?: (eventName: string) => void,
): void {
  if (!TRACKED_EVENTS.includes(eventName as TrackedEventName)) {
    reportAppWarning({
      scope: "trackChatEvent",
      metadata: { eventName },
      error: new Error(`Unknown chat event: ${eventName}`),
    });
    return;
  }

  const eventStatus = getEventStatus();

  if (!eventStatus[eventName as TrackedEventName]) {
    eventStatus[eventName as TrackedEventName] = true;
    sessionStorage.setItem("trackChatEvent", JSON.stringify(eventStatus));
    debugLog(`Tracking chat event: ${eventName}`);

    if (typeof onChatEvent === "function") {
      onChatEvent(eventName);
    }
  }
}
